export default {
    string: 'string',
    number: 'number',
    date: 'date',
    translate: 'translate',
    dictionary: 'dictionary',
    toggleCheckbox: 'toggleCheckbox',
    custom: 'custom'
};
